import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { Fragment } from "react/jsx-runtime";

const cardsData = [
  {
    id: 1,
    title: "Manual Booking",
    subTitle: `Directly handle reservations & booking requests from renters. Manually
  manage, confirm, negotiate payment terms, and coordinate with renters for
  all rentals using our owner dashboard.`,
  },
  {
    id: 2,
    title: "Instant Booking",
    subTitle: `Establish standard parameters and approval policies for rentals. Renters can directly book their chosen equipment without the need for manual approval`,
  },
];

const Card = ({
  title,
  subTitle,
  selected,
  onChange,
  id,
  userConfigLoading,
}: any) => (
  <Box
    onClick={() => !userConfigLoading && onChange(id)}
    sx={{
      cursor: "pointer",
      display: "flex",
      gap: "7px",
      border: `1px solid ${selected ? "#6E8C20" : "#E2E2E2"}`,
      flexDirection: "column",
      p: "12px",
      backgroundColor: selected ? "#E1FFA2" : "#fff",
      borderRadius: "5px",
      ...(userConfigLoading && { width: "100%" }),
    }}
  >
    <Typography fontSize={16} fontWeight={600} textAlign="left">
      {userConfigLoading ? (
        <Skeleton variant="text" sx={{ width: "auto", height: "20px" }} />
      ) : (
        title
      )}
    </Typography>
    <Typography fontSize={16} fontWeight={400}>
      {userConfigLoading ? (
        <Skeleton variant="text" sx={{ width: "auto", height: "60px" }} />
      ) : (
        subTitle
      )}
    </Typography>
  </Box>
);

const BookingTypeCards = (props: any) => {
  const { direction = "column", control, userConfigLoading } = props;
  return (
    <Controller
      control={control}
      name={"approval_policy_type"}
      // rules={{ ...FORM_VALIDATIONS.REQUIRED }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Fragment>
          <Stack
            direction={direction}
            justifyContent="center"
            alignItems={direction == "row" ? "strech" : "center"}
            spacing={2}
          >
            {cardsData?.map(({ title, subTitle, id }: any) => (
              <Card
                key={title}
                title={title}
                subTitle={subTitle}
                selected={id == value}
                onChange={onChange}
                id={id}
                userConfigLoading={userConfigLoading}
              />
            ))}
          </Stack>
          {!!error && (
            <Typography color="error" variant="caption">
              {"Please select approval policy" ?? ""}
            </Typography>
          )}
        </Fragment>
      )}
    />
  );
};

export default BookingTypeCards;
